import blankProfileIcon from '@shared/assets/images/blank-profile.svg?inline'
import botIcon from '@shared/assets/images/bot-icon.svg?inline'
import nonQliqUser from '@shared/assets/images/non-qliq-user.svg?inline'
import visitorUser from '@shared/assets/images/visitor-user.svg?inline'
import { Sizes } from '@shared/models/enums/chat-user-avatar'
import { ChatUserAvatar } from '@shared/models/interfaces/chat-user-avatar'
import { IParticipant } from '@shared/models/proto/base/participiant'
import { Nullable } from '@shared/models/types/primary'
import { getInitials } from '@shared/utils/helpers/string-formatter'

import { UserType } from '@protos/user_type_pb'

interface IParticipantAvatar {
  participants?: Nullable<IParticipant[]>
  sender?: IParticipant
  isNonQliq?: boolean
  isNonQliqPatient?: boolean
  visitantAvatar?: string
}

export const getParticipantAvatar = (
  participants?: Nullable<IParticipant[]>,
  chatUserId?: number
): string | null => {
  if (!participants?.length || !chatUserId) {
    return null
  }

  const participant = participants.find((el) => el.chatUserId === chatUserId)
  return participant?.avatar?.thumbnailUrl || null
}

const icons = {
  [UserType.BOT]: botIcon,
  [UserType.VISITOR]: visitorUser,
  [UserType.PATIENT]: visitorUser,
}

export const getAvatarData = (params: IParticipantAvatar): ChatUserAvatar => {
  const { participants, sender, isNonQliq, isNonQliqPatient, visitantAvatar } =
    params

  const isGuest =
    sender?.type === UserType.BOT ||
    sender?.type === UserType.VISITOR ||
    sender?.type === UserType.PATIENT

  if (isNonQliq) {
    return {
      src: isNonQliqPatient ? nonQliqUser : visitantAvatar || nonQliqUser,
    }
  }

  const participantAvatar = getParticipantAvatar(
    participants,
    sender?.chatUserId
  )

  const initials = getInitials(`${sender?.firstName} ${sender?.lastName ?? ''}`)

  if (participantAvatar) {
    return {
      src: participantAvatar,
      size: Sizes.FILL,
    }
  }

  if (isGuest) {
    return {
      src: icons[sender.type as keyof typeof icons],
    }
  }

  if (sender && initials) {
    return {
      initials,
    }
  }

  return {
    src: blankProfileIcon,
  }
}
